import React, { Component } from 'react'
import FrontPageItems from './FrontPageItems'
import AddServices from './AddServices'
import FeaturedEmployee from './FeaturedEmployee'


export default class FrontPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <React.Fragment>
        <div className="beach-parallax parallax d-flex justify-content-center align-items-center">
        <h1 className="main-photo-text text-center">
          Choose a place you want to visit and we will take care of the rest
        </h1>
      </div>
      <FrontPageItems />
      <AddServices />
      <FeaturedEmployee />
      </React.Fragment>
        
      
    )
  }
}
